import adminIntegracaoService from '../../services/admin/AdminIntegracaoService'

export const adminIntegracaoModule = {
  namespaced: true,

  state: {
    integracao: null,
    loading: false,
    saving: false,
  },

  mutations: {
    SET_INTEGRACAO(state, payload) {
      state.integracao = payload || null
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_SAVING(state, saving) {
      state.saving = saving
    },
  },

  actions: {
    async fetchIntegracao({ commit }) {
      commit('SET_LOADING', true)
      try {
        const response = await adminIntegracaoService.getIntegracao()
        commit('SET_INTEGRACAO', response?.data)
        return response
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async saveIntegracao({ commit }, payload) {
      commit('SET_SAVING', true)
      try {
        const response = await adminIntegracaoService.updateIntegracao(payload)
        if (response?.success) {
          commit('SET_INTEGRACAO', response?.data)
        }
        return response
      } finally {
        commit('SET_SAVING', false)
      }
    },
  },

  getters: {
    integracao: (state) => state.integracao,
    loadingIntegracao: (state) => state.loading,
    savingIntegracao: (state) => state.saving,
  },
}
